/* ============================================================
   KIRI — theme.js
   Scroll reveals · sticky header · mobile nav · variant picker
   · quick view (section rendering) · AJAX add to cart · cart page
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var R = (window.KIRI && window.KIRI.routes) || {};
  var S = (window.KIRI && window.KIRI.strings) || {};

  /* ---------------- toast ---------------- */
  var toastEl = document.getElementById('Toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------------- reveals ---------------- */
  var io = null;
  function initReveals(root) {
    if (document.body.classList.contains('no-anim') || reduce) {
      (root || document).querySelectorAll('.rev').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    (root || document).querySelectorAll('.rev:not(.in)').forEach(function (el) { io.observe(el); });
  }

  /* ---------------- header + parallax ---------------- */
  var hdr = document.getElementById('SiteHeader');
  function onScroll() {
    if (hdr) hdr.classList.toggle('is-stuck', window.scrollY > 8);
    if (reduce) return;
    document.querySelectorAll('[data-par]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var mid = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = 'translate3d(0,' + (-mid * parseFloat(el.dataset.par) * 100).toFixed(2) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () { window.requestAnimationFrame(onScroll); }, { passive: true });

  /* ---------------- mobile nav ---------------- */
  var burger = document.getElementById('Burger');
  function closeMenu() {
    document.body.classList.remove('menu-open', 'is-locked');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  if (burger) {
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('menu-open');
      document.body.classList.toggle('is-locked', open);
      burger.setAttribute('aria-expanded', String(open));
    });
    document.querySelectorAll('#MobileNav a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  /* ---------------- variant picker ----------------
     Works inside any container holding:
       [data-variant-json], [data-variant-id], .opt rows,
       [data-price], [data-add-button], [data-add-label]
  --------------------------------------------------*/
  function initVariants(root) {
    if (!root) return;
    var jsonEl = root.querySelector('[data-variant-json]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput  = root.querySelector('[data-variant-id]');
    var priceEl  = root.querySelector('[data-price]');
    var addBtn   = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var mainImg  = root.querySelector('[data-main-image] img') ||
                   (root.closest('.qv__panel') || document).querySelector('[data-main-image] img');
    var optRows  = Array.prototype.slice.call(root.querySelectorAll('.opt'));

    function selected() {
      return optRows.map(function (row) {
        var on = row.querySelector('.opt__btn[aria-pressed="true"]');
        return on ? on.dataset.optionValue : null;
      });
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function markAvailability() {
      var sel = selected();
      optRows.forEach(function (row, rowIndex) {
        row.querySelectorAll('.opt__btn').forEach(function (btn) {
          var probe = sel.slice();
          probe[rowIndex] = btn.dataset.optionValue;
          var match = variants.find(function (v) {
            return probe.every(function (val, i) { return val === null || v.options[i] === val; });
          });
          btn.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      var sel = selected();
      var complete = sel.every(function (v) { return v !== null; });
      var v = complete ? findVariant(sel) : null;

      markAvailability();

      if (!complete) {
        if (addBtn) { addBtn.disabled = false; }
        if (addLabel) { addLabel.textContent = S.addToCart || 'Add to bag'; }
        return;
      }
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = S.soldOut || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.has_compare ? '<s>' + v.compare_at + '</s> ' : '') + v.price;
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? (S.addToCart || 'Add to bag') : (S.soldOut || 'Sold out');
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); }
    }

    optRows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('.opt__btn');
        if (!btn) return;
        row.querySelectorAll('.opt__btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    // If a product has options but none preselected, leave unselected so the
    // customer must choose — matches how the template behaved.
    update();
  }

  /* ---------------- quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (!up && !down) return;
    var box = e.target.closest('[data-qty]');
    if (!box) return;
    var input = box.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, up ? val + 1 : val - 1);
  });

  /* ---------------- add to cart ---------------- */
  function cartCount() {
    return fetch(R.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('CartCount');
        if (el) el.textContent = cart.item_count;
        return cart;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form');
    if (!form) return;

    var root = form.closest('[data-product-root]') || form;
    var optRows = root.querySelectorAll('.opt');
    var unchosen = Array.prototype.some.call(optRows, function (row) {
      return !row.querySelector('.opt__btn[aria-pressed="true"]');
    });
    if (unchosen) {
      e.preventDefault();
      toast(S.chooseSize || 'Choose an option first');
      return;
    }

    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var label = form.querySelector('[data-add-label]');
    var prev = label ? label.textContent : '';
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
        return cartCount().then(function () {
          toast((res.data.title || '') + ' — ' + (S.added || 'added to bag'));
          closeQuickView();
        });
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = prev;
      });
  });

  /* ---------------- quick view ---------------- */
  var qv = document.getElementById('QuickView');
  var qvPanel = document.getElementById('QuickViewPanel');
  var lastFocus = null;

  function openQuickView(url) {
    if (!qv || !qvPanel) return;
    lastFocus = document.activeElement;
    var sep = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + sep + 'section_id=quick-view')
      .then(function (r) {
        if (!r.ok) throw new Error('Could not load');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.getElementById('shopify-section-quick-view') || doc.body;
        qvPanel.innerHTML = wrap.innerHTML;

        qv.hidden = false;
        window.requestAnimationFrame(function () { qv.classList.add('open'); });
        document.body.classList.add('is-locked');

        initVariants(qvPanel.querySelector('[data-product-root]'));
        var close = qvPanel.querySelector('[data-qv-close]');
        if (close) close.focus();
      })
      .catch(function () {
        // If the fetch fails for any reason, fall back to the product page.
        window.location.href = url;
      });
  }

  function closeQuickView() {
    if (!qv || !qv.classList.contains('open')) return;
    qv.classList.remove('open');
    document.body.classList.remove('is-locked');
    setTimeout(function () { qv.hidden = true; qvPanel.innerHTML = ''; }, 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      openQuickView(trigger.dataset.quickView);
      return;
    }
    if (e.target.closest('[data-qv-close]')) { closeQuickView(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (qv && qv.classList.contains('open')) closeQuickView();
      else if (document.body.classList.contains('menu-open')) closeMenu();
      return;
    }
    if (e.key === 'Tab' && qv && qv.classList.contains('open')) {
      var f = qv.querySelectorAll('button:not([disabled]), a[href], input, select, summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- cart page quantity ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-qty]');
    if (!b) return;
    var line = b.dataset.line;
    var input = document.querySelector('[data-cart-input][data-line="' + line + '"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    var next = b.dataset.cartQty === 'up' ? val + 1 : Math.max(0, val - 1);
    input.value = next;
    fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: next })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { toast('Could not update the bag'); });
  });

  /* ---------------- newsletter inline validation ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#NewsletterForm');
    if (!form) return;
    var input = form.querySelector('input[type="email"]');
    if (input && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim())) {
      e.preventDefault();
      toast('Please enter a valid email address');
    }
  });

  /* ---------------- boot ---------------- */
  function boot(root) {
    initReveals(root);
    initVariants((root || document).querySelector('[data-product-root]'));
  }
  boot(document);
  onScroll();

  /* Theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function () { onScroll(); });
})();
